import React from 'react'
import {Flex} from '/app/src/component'

class Dot extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            active: true
        }
    }

    render() {
        const {active} = this.props;
        if(active){
            return (
                <Flex backgroundColor='blue' borderRadius='10px' height='10px' width='10px' margin='0px 4px'/>
            )
        }

        return (
            <Flex backgroundColor='darkgrey' borderRadius='8px' height='8px' width='8px' margin='0px 4px'/>
        );
    }
}

export default Dot



// WEBPACK FOOTER //
// ./src/component/DotPagination/Dot.js